'use client'
import React, { ReactElement, useState } from 'react'
import HeaderCopyright from '@/components/headers/HeaderCopyright'
import Divider from '@/components/Divider'
import HeaderTestnet from '@/components/headers/HeaderTestnet'
import Navigation from '@/components/navigation/Navigation'

const NotYetErc414 = (): ReactElement => {
    const [leftOpen, setLeftOpen] = useState(false)

    return (
        <React.Fragment>
            <HeaderCopyright />
            <HeaderTestnet />
            <div className="main-container">
                <Navigation />
                <Divider />
                <h1 className={'white centered-row'}>NOT YET IMPLEMENTED</h1>
                <div className="centered-text gray">
                    Taking the ERC-404 standard to the next level.
                    <br />
                    Imagine a yet to be created ERC-414(!) standard. This new standard holds a NFT collection where each
                    NFT is based on ERC-404.
                    <br />
                    This opens up <i>CRAZY</i> LP tokenomics and makes the collection a complete eco-system in itself.
                </div>
            </div>
        </React.Fragment>
    )
}

export default NotYetErc414
